import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'
import { EmpresaList } from '../../empresas-list/core/_models'
import { getEmpresas } from '../../empresas-list/core/_requests'
import { useListFilters } from './ListFiltersProvider'

const QueryResponseContext = createResponseContext<EmpresaList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()
  const { filters } = useListFilters()
  const empresaId = filters.empresa?.value

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.CLIENTES_CONTRATOS_LIST, query, empresaId, isOpen],
    () => getEmpresas(query),
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !isOpen && !!empresaId,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{
        isLoading: isFetching,
        isError,
        refetch,
        response: empresaId ? response : undefined,
        query,
      }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
